import React, { useState, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { Tag } from '@components';
import { Tooltip } from 'antd';
import { API } from '@service';

// import '@style/components/buyerTargetInfo.scss';
import '../styles/components/buyerTargetInfo.scss';

const Info = ({
  type,
  data = '',
  industry,
  confidential,
  getPopupContainer,
}) => (
  <div className="info">
    <div className="title">{type}</div>
    {confidential ? (
      <div>Confidential</div>
    ) : (
      <div className="tool-tip-box">
        <Tooltip
          title={data || '-'}
          placement="bottomLeft"
          getPopupContainer={getPopupContainer}
          overlayClassName="tooltip-no-arrow"
        >
          <span className="text text-wrap">{data || '-'}</span>
        </Tooltip>
        {industry && (
          <Tooltip
            title={industry || ''}
            placement="bottomLeft"
            getPopupContainer={getPopupContainer}
            overlayClassName="tooltip-no-arrow"
          >
            <Tag className="text indicator-text">{industry}</Tag>
          </Tooltip>
        )}
      </div>
    )}
  </div>
);

const BuyerTargetInfo = () => {
  const [isShow, setIsShow] = useState();

  const { buyerLabel, targetLabel } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  const isInternal = JSON.parse(window.localStorage.userInfo || '{}').isInternal;
  const {
    buyerName,
    buyerIndustry,
    targetName,
    targetIndustry,
    projectId,
    isSingleCompany,
  } = useSelector(({ common }) => common.projectCompanyInfo);

  useEffect(() => {
    projectId &&
      API.getProjectStatus(projectId).then((res) => {
        if (res?.complexityOutputShowCompanyFlag) {
          setIsShow(res.complexityOutputShowCompanyFlag);
        }
      });
  }, [projectId]);

  return (
    <div className="buyer-target-info">
      {isInternal && (
        <div className="show-hide-controler">
          <Tooltip
            title={`${
              !isShow ? 'Show' : 'Hide'
            } ${buyerLabel} & ${targetLabel} Name`}
            placement="bottomLeft"
          >
            <div
              className={`access-indicator appkiticon icon-view-fill ${
                isShow ? 'unlock' : 'lock'
              }`}
              onClick={async () => {
                const res = await API.showHideComplexityCompany(projectId, {
                  projectStatusInfo: {
                    complexityOutputShowCompanyFlag: !isShow,
                  },
                });
                if (res?.message === 'save project status successfully') {
                  setIsShow(!isShow);
                }
              }}
            />
          </Tooltip>
        </div>
      )}
      {isShow && (
        <div className="project-info">
          <Info type={buyerLabel} data={buyerName} industry={buyerIndustry} />
          {!isSingleCompany && (
            <Info
              type={targetLabel}
              data={targetName}
              industry={targetIndustry}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default memo(BuyerTargetInfo);
export { Info };
